var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import * as React from "react";
import Communicator from "./Communicator";
import { useFeedbackValue } from "./Contexts/FeedbackContext";
import { useHostValue } from "./Contexts/HostContext";
import sendTimedMessage from "./Helper/timeMessageHelper";
import { ChatStates } from "./Interfaces/Stores/IHostStore";
import * as CommunicatorTypes from "./Types/CommunicatorTypes";
import * as Action from "./Types/ReducerTypes";
var useState = React.useState,
  useEffect = React.useEffect;
function CodeForm(_a) {
  var position = _a.position;
  var _b = useState(""),
    code = _b[0],
    setCode = _b[1];
  var _c = useState(""),
    chatUrl = _c[0],
    setChatUrl = _c[1];
  var _d = useFeedbackValue(),
    dispatchFeedback = _d[1];
  var _e = useHostValue(),
    state = _e[0],
    dispatchChat = _e[1];
  function openChat() {
    if (chatUrl !== "") {
      var startTime = Date.now();
      var newWindow_1 = window.open(chatUrl, "_blank");
      if (newWindow_1 !== null) {
        var closerCheck_1 = setInterval(function () {
          if (newWindow_1.closed) {
            if (window.layoutSettings.hash !== '') {
              dispatchChat({
                type: Action.END_CHAT,
                running: ChatStates.NO
              });
            } else {
              dispatchChat({
                type: Action.END_CHAT,
                running: ChatStates.SURVEY
              });
            }
            clearInterval(closerCheck_1);
          }
        }, 500);
      }
    }
  }
  function onSubmit(evt) {
    evt.preventDefault();
    Communicator.sendMessage(CommunicatorTypes.SEND_LIVECAM_CODE, {
      adtv: window.paramADTV,
      code: code,
      layout: window.layoutSettings.hash,
      useragent: navigator.userAgent,
      w: window.paramW,
      wo: window.ABTestOption,
      ws: window.paramWS,
      wt: window.paramWT
    });
  }
  useEffect(function () {
    function wrongCode() {
      var message = {
        type: "warning",
        text: "Dieser Code ist leider ungültig."
      };
      sendTimedMessage(message, dispatchFeedback);
    }
    function handleChat(message) {
      if (message.chatUrl) {
        // Old Version handling
        dispatchChat(__assign(__assign({
          type: Action.START_CHAT
        }, message), {
          running: ChatStates.OLD,
          client: 'oldPlayer'
        }));
        setChatUrl(message.chatUrl);
      } else {
        // New Player
        dispatchChat(__assign(__assign({
          type: Action.START_CHAT
        }, message), {
          running: ChatStates.NEW,
          client: 'newPlayer'
        }));
        setCode('');
      }
    }
    if (!Communicator.hasMessageHandlerForType(CommunicatorTypes.WRONG_LIVECAM_CODE)) {
      Communicator.registerMessageHandler(CommunicatorTypes.WRONG_LIVECAM_CODE, wrongCode);
    }
    Communicator.registerMessageHandler(CommunicatorTypes.VIDEO_STREAM_DATA, handleChat);
    return function () {
      Communicator.unregisterMessageHandler(CommunicatorTypes.WRONG_LIVECAM_CODE, wrongCode);
      Communicator.unregisterMessageHandler(CommunicatorTypes.VIDEO_STREAM_DATA, handleChat);
    };
  }, []);
  if (chatUrl !== '') {
    return /*#__PURE__*/React.createElement("div", {
      className: "codeForm c-codeform"
    }, /*#__PURE__*/React.createElement("form", null, /*#__PURE__*/React.createElement("input", {
      className: "c-codeform__button",
      type: "submit",
      value: "Chat \u00F6ffnen",
      onClick: openChat
    })));
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "codeForm c-codeform"
  }, /*#__PURE__*/React.createElement("form", {
    onSubmit: onSubmit
  }, /*#__PURE__*/React.createElement("label", null, /*#__PURE__*/React.createElement("span", {
    className: "codetext c-codeform__label"
  }, "Code:"), /*#__PURE__*/React.createElement("input", {
    className: "c-codeform__input",
    placeholder: "12345",
    id: "pineingabe",
    type: 'number',
    value: code,
    onChange: function (e) {
      return setCode(e.target.value);
    }
  })), /*#__PURE__*/React.createElement("input", {
    type: "submit",
    className: "c-codeform__button",
    value: "Start"
  })));
}
export default CodeForm;